/**
 * PREVENTION-ACTION-CARD
 * Habillage commun des mesures de prevention : bordure grise, fond bleu tant que la mesure n'est
 * pas realisee. Le controle de statut est optionnel : une simple proposition n'en a pas.
 */
import { ReactNode } from "react"
import getColor from "@/utils/get-color.utils"

interface Props {
  children: ReactNode
  control?: ReactNode //Case de statut, a gauche du libelle
  isDashed?: boolean //Action d'ajout : meme carte avec une bordure pointillee
  isToPlan?: boolean //Yellow highlight when no due date is defined
  isOverdue?: boolean //Orange highlight for overdue planned measures
  isDone?: boolean //Mesure realisee : fond blanc
  onClick?: () => void
}

export default function PreventionActionCard({
  children,
  control,
  isDashed,
  isDone,
  isOverdue,
  isToPlan,
  onClick
}: Props) {
  const accent = getColor(isOverdue ? "orange" : isToPlan ? "yellow" : "blue")
  return (
    <div
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      className={`${onClick ? "_hover" : ""} flex min-h-[46px] items-center gap-[14px] rounded-[12px] px-[16px] py-[10px]`}
      style={{
        border: `1px ${isDashed ? "dashed" : "solid"} ${(isOverdue || isToPlan) && !isDone ? accent : "#CBD5E1"}`,
        backgroundColor: isDashed || isDone ? "white" : `${accent}1A`
      }}
      onKeyDown={
        onClick
          ? (event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault()
                onClick()
              }
            }
          : undefined
      }
      onClick={onClick}>
      {control}
      <span
        className="flex min-w-0 flex-1 flex-col items-start text-left font-normal leading-snug"
        style={{ color: "#263248" }}>
        {children}
      </span>
    </div>
  )
}
